import { defineComponent as n, computed as l, openBlock as i, createElementBlock as a, createElementVNode as e, toDisplayString as r, createCommentVNode as f, normalizeStyle as h } from "vue";
const _ = ["viewBox"], v = /* @__PURE__ */ e("mask", { id: "94ca7d5b-f2ed-4146-afba-02d2e7079d5b" }, [
  /* @__PURE__ */ e("circle", {
    cx: "256",
    cy: "256",
    r: "256",
    fill: "#fff"
  })
], -1), u = { mask: "url(#94ca7d5b-f2ed-4146-afba-02d2e7079d5b)" }, m = { key: 0 }, p = /* @__PURE__ */ e("path", {
  fill: "#338af3",
  d: "M0 256 256 0h256v55.7l-20.7 34.5 20.7 32.2v66.8l-21.2 32.7L512 256v66.8l-24 31.7 24 35.1v66.7l-259.1 28.3L0 456.3v-66.7l27.1-33.3L0 322.8z"
}, null, -1), k = /* @__PURE__ */ e("path", {
  fill: "#eee",
  d: "M256 256h256v-66.8H236.9zm-19.1-133.6H512V55.7H236.9zM512 512v-55.7H0V512zM0 389.6h512v-66.8H0z"
}, null, -1), g = /* @__PURE__ */ e("path", {
  fill: "#eee",
  d: "M0 0h256v256H0z"
}, null, -1), z = /* @__PURE__ */ e("path", {
  fill: "#ffda44",
  d: "m222.6 149.8-31.3 14.7 16.7 30.3-34-6.5-4.3 34.3-23.6-25.2-23.7 25.2-4.3-34.3-33.9 6.5 16.6-30.3-31.2-14.7 31.2-14.7-16.6-30.3 34 6.5 4.2-34.3 23.7 25.3L169.7 77l4.3 34.3 34-6.5-16.7 30.3z"
}, null, -1), x = { fill: "none" }, w = ["r"], W = /* @__PURE__ */ n({
  __name: "uy",
  props: {
    flagName: {},
    strokeColor: { default: "#000" },
    strokeWidth: { default: 0 }
  },
  setup(c) {
    const t = c, o = l(() => 512 + 2 * t.strokeWidth), s = l(() => -t.strokeWidth), d = l(() => 256 + t.strokeWidth / 2);
    return (y, b) => (i(), a("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "svg-circle-flags",
      viewBox: `${s.value} ${s.value} ${o.value} ${o.value}`
    }, [
      v,
      e("g", u, [
        t.flagName ? (i(), a("title", m, r(t.flagName), 1)) : f("", !0),
        p,
        k,
        g,
        z
      ]),
      e("g", x, [
        e("circle", {
          cx: "256",
          cy: "256",
          r: d.value,
          fill: "none",
          style: h({ stroke: t.strokeColor, strokeWidth: t.strokeWidth })
        }, null, 12, w)
      ])
    ], 8, _));
  }
});
export {
  W as default
};
//# sourceMappingURL=uy-85cfb131.js.map
